var render = function (_h,_vm) {var _c=_vm._c;return _c('nav',{staticClass:"tabs tabbing-nav"},[_c('ul',_vm._l((_vm.props.tabs),function(t){return _c('li',{key:t,class:{ 'is-active': t === _vm.props.value }},[_c('a',{on:{"click":function($event){return _vm.$options.select(_vm.listeners, t)}}},[_c('span',[_vm._v(_vm._s(t))])])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }